// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__7y2k2","list":"styles_list__tzodv"};